import React from 'react';

import classNames from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './ModalTaskElement.module.css';
import { useModalTaskElement } from './useModalTaskElement';
import { Icon } from '../../../../../../../components/newUI/Icon/Icon';

interface ModalTaskElementProps {
    classes?: string;
}
// todo компонент пока что не используется
export const ModalTaskElement = ({ classes }: ModalTaskElementProps) => {
    const {} = useModalTaskElement();
    return (
        <div className={classNames(cls.ModalTaskElement, [classes])}>
            <div className={cls.Content}>
                <div className={cls.TaskHeader}>
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect width="32" height="32" rx="16" fill="#E4F0FF" />
                        <g clipPath="url(#clip0_1742_17096)">
                            <path
                                d="M17.6666 7.83268C17.1277 7.72268 16.5722 7.66713 16 7.66602C11.3975 7.66602 7.66663 11.3968 7.66663 15.9993C7.66663 20.6018 11.3975 24.3327 16 24.3327C20.6025 24.3327 24.3333 20.6018 24.3333 15.9993C24.3322 15.4271 24.2766 14.8716 24.1666 14.3327"
                                stroke="#67ABFF"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M15.9999 13.4988C15.0791 13.4988 14.3333 14.0588 14.3333 14.7488C14.3333 15.4388 15.0791 15.9988 15.9999 15.9988C16.9208 15.9988 17.6666 16.5588 17.6666 17.2488C17.6666 17.9388 16.9208 18.4988 15.9999 18.4988M15.9999 13.4988C16.7249 13.4988 17.3433 13.8463 17.5716 14.3321M15.9999 13.4988V12.6655M15.9999 18.4988C15.2749 18.4988 14.6566 18.1513 14.4283 17.6655M15.9999 18.4988V19.3321M20.1649 11.8338L23.6449 8.35214M24.3316 11.3988L24.2333 8.8238C24.2333 8.2163 23.8708 7.83797 23.2099 7.79047L20.6066 7.66797"
                                stroke="#67ABFF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1742_17096">
                                <rect
                                    width="20"
                                    height="20"
                                    fill="white"
                                    transform="translate(6 6)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                    <span className={cls.Title}>Оплатить Заявки на оплату №5</span>
                </div>
                <div className={cls.TaskInfo}>
                    <span className={cls.Text}>Захарьевская 12</span>
                    <span className={cls.Text}>/</span>
                    <span className={cls.Text}>Фудамент</span>
                </div>
            </div>
            <UiButton
                className={cls.Button}
                variant="icon"
                onClick={() => 1}
                startIcon={<Icon iconName="navigationNext" />}
            />
        </div>
    );
};
